import type { RecordingStats } from "@sunrise/backend-types";
import type { Nullable } from "@sunrise/utils";
import { atom } from "jotai";

export const recordingStatsSocketAtom = atom<Nullable<RecordingStats>>(null);
